import HttpStatus from 'http-status-codes';
import store from '../store';
import { capitalize, notify } from '../utils';

/**
 * authOnly guards the route against access from unauthenticated users.
 */
export const authOnly = async (to, from, next) => {
  try {
    await store.dispatch('auth/fetchUser');
    
    next();
  } catch (err) {
    if (err.response && err.response.status === HttpStatus.UNAUTHORIZED) {
      if (localStorage) {
        localStorage.setItem('redirect_after_oauth', to.fullPath || to.path);
      }
    
      next({ name: 'home' });
      return;
    }

    throw err;
  }
};

/**
 * hasPermissionsTo returns a guard which checks whether the user
 * has permission to enter that route, and throws an error if not.
 * 
 * @param {String[]} permissions
 */
export const hasPermissionsTo = (permissions) => async (to, from, next) => {
  try {
    await store.dispatch('auth/fetchUser');

    const hasPermissionsTo = store.getters['auth/hasPermissionsTo'];
    if (!hasPermissionsTo(permissions)) {
      const permissionTitles = permissions.map(permission => (
        String(permission).split('-')
          .map(s => capitalize(s))
          .join(' ')
      ))
      .join(', ');

      notify(`Sorry, you do not have permission to ${permissionTitles}`, 'warning');

      next({ name: from.name || 'admin' });
      return;
    }

    next();
  } catch (err) {
    if (err.response && err.response.status === HttpStatus.UNAUTHORIZED) {
      next({ name: 'home' });
      return;
    }

    throw err;
  }
};
